import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = '/api/superadmin';

const emptyForm = {
  name: '', surname: '', email: '', mobile_number: '', password: '',
  father_husband: '', dob: '', address1: '', address2: '', pincode: '',
  district: '', state: '', spounce_name: '', spounce_mobile: '',
  refered_by: '', isd: '91', is_active: true,
};

const SuperAdminDealersPage = () => {
  const [dealers,  setDealers]  = useState([]);
  const [selected, setSelected] = useState('');
  const [form,     setForm]     = useState(null);
  const [isNew,    setIsNew]    = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [msg,      setMsg]      = useState('');
  const [loading,  setLoading]  = useState(true);

  const token   = localStorage.getItem('ep_token');
  const headers = { Authorization: `Bearer ${token}` };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/users/dealers`, { headers });
      setDealers(data);
    } catch { /* ignore */ }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const selectDealer = (id) => {
    setSelected(id); setIsNew(false); setMsg('');
    if (!id) { setForm(null); return; }
    const d = dealers.find(x => String(x.id) === String(id));
    if (!d) return;
    setForm({
      name:           d.Name           || '',
      surname:        d.Surname        || '',
      email:          d.email          || '',
      mobile_number:  d.mobile_number  || '',
      password:       '',
      father_husband: d.father_husband || '',
      dob:            d.dob ? String(d.dob).split('T')[0] : '',
      address1:       d.address1       || '',
      address2:       d.address2       || '',
      pincode:        d.pincode        || '',
      district:       d.District       || d.district || '',
      state:          d.state          || '',
      spounce_name:   d.SpounceName    || d.spounce_name || '',
      spounce_mobile: d.SpounceMobile  || d.spounce_mobile || '',
      refered_by:     d.refered_by     || '',
      isd:            d.isd            || '91',
      is_active:      d.is_active === 1 || d.is_active === true,
    });
  };

  const addNew = () => {
    setSelected(''); setIsNew(true); setMsg('');
    setForm({ ...emptyForm });
  };

  const save = async () => {
    setSaving(true); setMsg('');
    try {
      const payload = { ...form, role: 'dealer' };
      if (!payload.password) delete payload.password;
      if (isNew) {
        await axios.post(`${API}/users`, payload, { headers });
        setMsg('Dealer created successfully.');
        setIsNew(false); setForm(null);
      } else {
        await axios.put(`${API}/users/${selected}`, payload, { headers });
        setMsg('Saved successfully.');
      }
      await load();
    } catch (err) {
      setMsg(err.response?.data?.error || 'Save failed.');
    }
    setSaving(false);
  };

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div style={s.page}>
      <div style={s.topBar}>
        <h2 style={s.title}>🏪 Dealers</h2>
        <button style={s.addBtn} onClick={addNew}>+ Add Dealer</button>
      </div>

      {loading ? (
        <p style={{ color: '#888', padding: '2rem' }}>Loading…</p>
      ) : (
        <div style={s.layout}>
          {/* Left: dealer list */}
          <div style={s.list}>
            {dealers.length === 0 && <p style={s.empty}>No dealers found.</p>}
            {dealers.map(d => (
              <div
                key={d.id}
                onClick={() => selectDealer(String(d.id))}
                style={{
                  ...s.dealerItem,
                  background: String(selected) === String(d.id) ? '#e0e7ff' : '#fff',
                  borderLeft: String(selected) === String(d.id) ? '3px solid #4f46e5' : '3px solid transparent',
                }}
              >
                <Avatar name={d.Name} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={s.dName}>{d.Surname ? `${d.Surname} ${d.Name}` : d.Name}</div>
                  <div style={s.dSub}>{d.mobile_number} · {d.email || '—'}</div>
                </div>
                {!d.is_active && <span style={s.inactiveBadge}>Inactive</span>}
              </div>
            ))}
          </div>

          {/* Right: edit form */}
          <div style={s.formPanel}>
            {!form && !isNew && (
              <div style={s.placeholder}>
                <div style={{ fontSize: '3rem', marginBottom: 12 }}>🏪</div>
                <p style={{ color: '#888' }}>Select a dealer to edit, or click <strong>+ Add Dealer</strong></p>
              </div>
            )}
            {form && (
              <div style={s.formScroll}>
                <h3 style={s.formTitle}>{isNew ? 'New Dealer' : 'Edit Dealer'}</h3>
                {msg && <div style={msg.includes('uccess') ? s.ok : s.err}>{msg}</div>}
                <FormGrid form={form} f={f} />
                <div style={s.actions}>
                  <button style={s.saveBtn} onClick={save} disabled={saving}>
                    {saving ? 'Saving…' : isNew ? 'Create Dealer' : 'Save Changes'}
                  </button>
                  <button style={s.cancelBtn} onClick={() => { setForm(null); setSelected(''); setIsNew(false); setMsg(''); }}>
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// ── Avatar ────────────────────────────────────────────────────────────────────
const Avatar = ({ name, color = '#065f46' }) => {
  const initials = (name || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  return (
    <div style={{ width: 36, height: 36, borderRadius: '50%', background: color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, flexShrink: 0 }}>
      {initials}
    </div>
  );
};

// ── Shared form grid ──────────────────────────────────────────────────────────
export const FormGrid = ({ form, f }) => {
  const inp = (label, key, type = 'text', placeholder = '') => (
    <div style={s.field}>
      <label style={s.label}>{label}</label>
      <input style={s.input} type={type} placeholder={placeholder} value={form[key] || ''}
        onChange={e => f(key, e.target.value)} />
    </div>
  );

  return (
    <div style={s.grid}>
      {inp('Surname', 'surname', 'text', 'Last name')}
      {inp('Name', 'name', 'text', 'First name')}
      {inp('Mobile', 'mobile_number', 'tel', '10-digit')}
      {inp('Email', 'email', 'email', 'email@example.com')}
      {inp('Password', 'password', 'password', 'Leave blank to keep')}
      {inp('Father / Husband', 'father_husband')}
      {inp('Date of Birth', 'dob', 'date')}
      {inp('Address Line 1', 'address1')}
      {inp('Address Line 2', 'address2')}
      {inp('Pincode', 'pincode', 'text', '6 digits')}
      {inp('District', 'district')}
      {inp('State', 'state')}
      {inp('Spouse Name', 'spounce_name')}
      {inp('Spouse Mobile', 'spounce_mobile', 'tel')}
      {inp('Referred By', 'refered_by')}
      {inp('ISD', 'isd', 'text', '91')}
      <div style={{ ...s.field, gridColumn: 'span 2' }}>
        <label style={{ ...s.label, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
          <input type="checkbox" checked={!!form.is_active} onChange={e => f('is_active', e.target.checked)} />
          Active Account
        </label>
      </div>
    </div>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────
const s = {
  page:         { padding: '1.5rem', maxWidth: 1100, margin: '0 auto' },
  topBar:       { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.25rem' },
  title:        { fontSize: '1.25rem', fontWeight: 800, color: '#1a1a2e', margin: 0 },
  addBtn:       { background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  layout:       { display: 'flex', gap: '1.5rem', alignItems: 'flex-start' },
  list:         { width: 280, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 4 },
  dealerItem:   { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', border: '1px solid #e5e7eb', transition: 'background 0.15s' },
  dName:        { fontWeight: 700, fontSize: 13, color: '#1a1a2e', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  dSub:         { fontSize: 11, color: '#888', marginTop: 1 },
  inactiveBadge:{ background: '#fef2f2', color: '#dc2626', fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 10 },
  empty:        { color: '#888', fontSize: 14 },
  formPanel:    { flex: 1, background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', minHeight: 300 },
  placeholder:  { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 300 },
  formScroll:   { padding: '1.5rem' },
  formTitle:    { margin: '0 0 1rem', fontSize: '1rem', fontWeight: 800, color: '#1a1a2e' },
  ok:           { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#15803d', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: 13 },
  err:          { background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: 13 },
  grid:         { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' },
  field:        { display: 'flex', flexDirection: 'column', gap: 3 },
  label:        { fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.04em' },
  input:        { padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, outline: 'none' },
  actions:      { display: 'flex', gap: 10, marginTop: '1.25rem' },
  saveBtn:      { background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 22px', fontWeight: 700, fontSize: 14, cursor: 'pointer' },
  cancelBtn:    { background: '#f1f5f9', color: '#555', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 18px', fontWeight: 600, fontSize: 14, cursor: 'pointer' },
};

export { Avatar };
export default SuperAdminDealersPage;
